import React, { useState, useRef, useEffect } from 'react';
import { FaChevronDown } from 'react-icons/fa';
import { IoCheckmark } from 'react-icons/io5';
import './dropdown.css';

const Dropdown = ({ title, options, selectedOption, onSelect }) => {
  const [showOptions, setShowOptions] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = useRef(null);

  const handleOptionClick = (option) => {
    onSelect(option);
    setShowOptions(false);
    setSearchTerm(''); 
  };

  const toggleOptions = () => {
    setShowOptions(!showOptions);
    if (!showOptions) setSearchTerm(''); 
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value.trim()); // Optional: Trim for cleaner search
  };

  const filteredOptions = options.filter(option =>
    option.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowOptions(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="dropdown-field" ref={dropdownRef}>
      <div className="custom-dropdown">
        <div className="dropdown-header" onClick={toggleOptions}>
          <input
            type="text"
            value={selectedOption?.label || ''}
            placeholder={title}
            readOnly
          />
          <FaChevronDown />
        </div>
        {showOptions && (
          <div className="dropdown-options">
            {/* Search Box */}
            <input
              type="text"
              className="dropdown-search"
              placeholder="Search..."
              value={searchTerm}
              onChange={handleSearch}
            />
            
            {/* Filtered Options */}
            {filteredOptions.length > 0 ? (
              filteredOptions.map((option, index) => (  // Added index for fallback
                <p 
                  key={option.value || `opt-${index}`}  // <-- FIX: Safe unique key
                  onClick={() => handleOptionClick(option)}
                >
                  <span>{option.label}</span>
                  {selectedOption?.value === option.value && (
                    <span><IoCheckmark size={16} /></span>
                  )}
                </p>
              ))
            ) : (
              <p key="no-results" className="no-options">No results found</p>  // <-- Optional: Key for consistency
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Dropdown;